<template>
<div id="giftcard-payment" :class="isPhone ? 'giftcard-payment-phone' : ''">
  <div class="container-giftcard pb-5" v-if="!bookingConfirmed">
    <div class="row row-giftcard">
      <div class="col-12 col-md-7 order-2 order-md-1 col-info-left">
        <div class="d-flex flex-column justify-content-center align-items-start w-100">
          <div class="d-flex justify-content-start align-items-start mb-4" v-if="!isPhone" @click="close()">
            <div class="back-button d-flex align-items-center">
              <img src="../../images/arrow-left-small.svg" alt="Back" style="width: 23px; height: 17.5px;" />
            </div>
          </div>
          
          <!-- Reassurance section -->
          <GiftcardReassurance class="mb-2" />

          <!-- Step 1: Nos Cartes Cadeaux -->
          <div id="step-1" class="pt-4 d-flex flex-column justify-content-center align-items-start w-100 mt-4 giftcard-selection-section" :class="currentStep !== 1 ? 'border-bottom-gray pb-4' : ''">
            <div class="raleway-medi-p18 d-flex justify-content-between w-100">
              <span>1. Nos cartes cadeaux</span>
              <span v-if="currentStep !== 1" class="link-text raleway-medi-p13" @click="currentStep = 1">Modifier</span>
            </div>
            <div class="w-100 position-relative" v-if="currentStep == 1">
              <div class="d-flex align-items-center row no-gutters pt-3">
                <!-- Amount -->
                <div class="col-12 col-md-3 d-flex flex-column gift-card-input">
                  <label class="form-label text-uppercase raleway-medi-p15">Montant</label>
                  <v-select
                    id="amount"
                    class="select-item no-border"
                    :class="{ 'dropdown-up': isPhone }"
                    placeholder=""
                    v-model="giftcardPurchase.amount"
                    :options="amountsList"
                    label="name"
                    :appendToBody="isPhone ? false : true"
                    :reduce="option => option.id"
                  />
                </div>
              </div>
              <div v-if="currentStep == 1" class="d-flex flex-row justify-content-center align-items-center w-100 pt-5" :class="isPhone ? 'px-4' : ''">
                <div class="hortense-btn-primary" @click="changeStep(2)">
                  PASSEZ À L'ÉTAPE SUIVANTE
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: Informations -->
          <div id="step-2" class="pt-4 d-flex flex-column justify-content-center align-items-start w-100 information-section" :class="currentStep !== 2 ? 'border-bottom-gray pb-4' : ''">
            <div class="raleway-medi-p18">
              2. Informations
            </div>
            <div class="w-100" v-if="currentStep == 2">
              <div class="d-flex flex-column align-items-center my-4" style="gap: 10px;">
                <div class="d-flex align-items-start gap-2" style="width: 350px;">
                  <input
                    type="checkbox"
                    id="personal"
                    :checked="giftcardPurchase.purchase_type === 'personal'"
                    @change="togglePurchaseType('personal')"
                    class="mt-1"
                  />
                  <label for="personal" class="raleway-reg-p15 mb-0">
                    <span class="ml-2 text-nowrap">Je m'offre une carte cadeau</span>
                  </label>
                </div>

                <div class="d-flex align-items-start gap-2" style="width: 350px;">
                  <input
                    type="checkbox"
                    id="entreprise"
                    :checked="giftcardPurchase.purchase_type === 'entreprise'"
                    @change="togglePurchaseType('entreprise')"
                    class="mt-1"
                  />
                  <label for="entreprise" class="raleway-reg-p15 mb-0">
                    <span class="ml-2 text-nowrap">J'achète pour le compte d'une entreprise</span>
                  </label>
                </div>
              </div>

              <div v-if="giftcardPurchase.purchase_type === 'beneficiary'">
                <p class="raleway-semi-p15">À l'attention de</p>
                <div class="line-form row mb-2">
                  <label for="receiver_last_name" class="col-12 col-md-6">
                    Nom*
                    <input v-model="giftcardPurchase.receiver.last_name" type="text" id="receiver_last_name" />
                  </label>
                  <label for="receiver_first_name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                    Prénom*
                    <input v-model="giftcardPurchase.receiver.first_name" type="text" id="receiver_first_name" />
                  </label>
                </div>
                <div class="line-form row mb-2">
                  <label for="receiver_email" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Email*
                    <input v-model="giftcardPurchase.receiver.email" type="text" id="receiver_email" />
                  </label>
                </div>

                <p class="raleway-semi-p15 pt-4">De la part de</p>
                <div class="line-form row mb-2">
                  <label for="sender_last_name" class="col-12 col-md-6">
                    Nom*
                    <input v-model="giftcardPurchase.sender.last_name" type="text" id="sender_last_name" />
                  </label>
                  <label for="sender_first_name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                    Prénom*
                    <input v-model="giftcardPurchase.sender.first_name" type="text" id="sender_first_name" />
                  </label>
                </div>
                <div class="line-form row mb-2">
                  <label for="sender_email" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Email*
                    <input v-model="giftcardPurchase.sender.email" type="text" id="sender_email" />
                  </label>
                </div>
                <p class="raleway-light-italic-13 light-gray-text">(* champs obligatoires)</p>
              </div>

              <div v-if="giftcardPurchase.purchase_type === 'personal'">
                <div class="col-12">
                  <div class="line-form row mb-2">
                    <label for="name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                      Nom*
                      <input v-model="giftcardPurchase.sender.last_name" :disabled="user ? true : false" type="text" />
                    </label>
                    <label for="name" class="col-12 col-md-6">
                      Prénom*
                      <input v-model="giftcardPurchase.sender.first_name" :disabled="user ? true : false" type="text" />
                    </label>
                  </div>
                  <div class="line-form row mb-2">
                    <label for="name" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                      Email*
                      <input v-model="giftcardPurchase.sender.email" :disabled="user ? true : false" type="text" />
                    </label>
                  </div>
                  <p class="raleway-light-italic-13 light-gray-text">(* champs obligatoires)</p>
                </div>
              </div>

              <div v-if="giftcardPurchase.purchase_type === 'entreprise'" class="col-12">
                <div class="line-form row mb-2">
                  <label for="company_name" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Nom de la société *
                    <input v-model="giftcardPurchase.sender.company_name" type="text" id="company_name" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="vat_number" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    N° de TVA *
                    <input v-model="giftcardPurchase.sender.vat_number" type="text" id="vat_number" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="last_name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                    Nom *
                    <input v-model="giftcardPurchase.sender.last_name" :disabled="user ? true : false" type="text" id="last_name" />
                  </label>

                  <label for="first_name" class="col-12 col-md-6">
                    Prénom *
                    <input v-model="giftcardPurchase.sender.first_name" :disabled="user ? true : false" type="text" id="first_name" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="phone" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Numéro de téléphone *
                    <input v-model="giftcardPurchase.sender.phone" type="text" id="phone" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="email" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Email professionnel *
                    <input v-model="giftcardPurchase.sender.email" :disabled="user ? true : false" type="text" id="email" />
                  </label>
                </div>

                <p class="raleway-light-italic-13 light-gray-text">(* champs obligatoires)</p>
              </div>

              <div v-if="currentStep == 2" class="d-flex flex-row justify-content-center align-items-center w-100 pt-5" :class="isPhone ? 'px-4' : ''">
                <div class="hortense-btn-primary" @click="changeStep(3)">
                  PASSEZ À L'ÉTAPE SUIVANTE
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Personnalisation -->
          <div id="step-3" class="pt-4 d-flex flex-column justify-content-center align-items-start w-100 personalise-section" :class="currentStep !== 3 ? 'border-bottom-gray pb-4' : ''">
            <div class="raleway-medi-p18">
              3. Personnalisation
            </div>
            <div class="w-100 pt-3" v-if="currentStep == 3">
              <p class="raleway-reg-p15">Vous avez la possibilité d'ajouter un message personnalisé qui apparaîtra sur la carte cadeau.</p>
              <textarea 
                v-model="giftcardPurchase.personal_message" 
                placeholder="Votre Message" 
                class="line-form form-text-area" 
                name="personal_message"
              ></textarea>
              
              <div class=" d-flex pt-3" :class="isPhone ? 'align-items-start' : 'align-items-center'">
                <img src="../../images/info.svg" v-set-alt />
                <p class="raleway-reg-p15 mb-0" :class="isPhone ? '' : 'ml-2'">Vous avez la possibilité de programmer l'envoi de la carte cadeau à une date ultérieure.</p>
              </div>
              <p class="raleway-semi-p15 mb-1 pt-3">
                VEUILLEZ INDIQUER LA DATE SOUHAITÉE.
              </p>
              <p class="raleway-reg-p15">Sans indication de votre part, la carte sera envoyée immédiatement après la confirmation de l'achat.</p>
              <div class="d-flex flex-row justify-content-center align-items-center w-100 pt-3">
                <div class="d-flex justify-content-center align-items-center date-picker-container">
                  <div class="raleway-medi-p15 d-flex justify-content-center align-items-center" style="gap: 18px;">
                    <p class="mb-0">Date d'envoi de la carte</p>
                    <div class="calendar-container">
                      <span class="calendar-icon" @click="handleCalendarIconClick"></span>
                      <VueDatePicker
                        v-model="giftcardPurchase.scheduled_date"
                        format="DD/MM/YYYY"
                        placeholder="JJ/MM/AAAA"
                        :no-calendar-icon="true"
                        class="calendar-input"
                        :locale="{lang: 'fr'}"
                        :noHeader="true"
                        color="#3B6152"
                      >
                      </VueDatePicker>  
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="currentStep == 3" class="d-flex flex-row justify-content-center align-items-center w-100 pt-5" :class="isPhone ? 'px-4' : ''">
                <div class="hortense-btn-primary" @click="changeStep(4)">
                  PASSEZ À L'ÉTAPE SUIVANTE
                </div>
              </div>
            </div>
          </div>

          <!-- Step 4: Paiement -->
          <div id="step-4" class="pt-4 d-flex flex-column justify-content-center align-items-start w-100 payment-section" :class="currentStep !== 4 ? 'border-bottom-gray pb-4' : ''">
            <div class="raleway-medi-p18">
              4. Paiement
            </div>
            <div class="section-payment w-100 pt-3" v-if="currentStep == 4">
              <div class="link-container d-flex flex-column">
                <p class="raleway-bold-p14 d-flex w-full justify-content-center mb-2 text-uppercase">{{ $t("payment") }}</p>
                <div class="d-flex align-items-center justify-content-center payment-icons">
                  <img style="height: 42px;" src="../../images/pay1-color.svg" v-set-alt>
                  <img style="height: 42px;" src="../../images/pay2-color.svg" v-set-alt>
                  <img style="height: 42px;" src="../../images/pay3-color.svg" v-set-alt>
                </div>
              </div>
              <div class="card-stripe mb-3 pt-3" :class="isPhone ? 'row' : ''">
                <div class="raleway-bold-p16 text-uppercase pb-4" :class="isPhone ? 'd-flex justify-content-start w-100' : ''">
                  <p class="raleway-bold-p16 mb-0" :class="isPhone ? 'text-center w-100' : ''">Carte de crédit</p>
                </div>
                <div class="field">
                  <input type="text" placeholder="Nom/Prénom" v-model="cardDetails.holder" />
                </div>
                <div class="field">
                  <div id="card-number" placeholder="1234  1234  1234  1234" class="input empty"></div>
                </div>
                <div class="field">
                  <div id="card-expiry" placeholder="MM / AA" class="input empty"></div>
                </div>
                <div class="field">
                  <div id="card-cvc" placeholder="CVC" class="input empty"></div>
                </div>
                <div id="card-errors" role="alert" ref="errorsCard"></div>

                <div class="form-item raleway-reg-p12 pt-3">
                  <input
                    type="checkbox"
                    id="payment-accept"
                    value="payment-accept"
                    v-model="acceptConditions"
                  />
                  <label for="payment-accept">J'accepte les <a class="link-hortense" href="/conditions-generales-utilisation" target="_blank">conditions générales d'utilisation.</a></label>
                </div>
                <div class="d-flex pt-3" :class="isPhone ? 'w-100 px-4' : 'justify-content-center'">
                  <button class="hortense-btn-primary w-100" :disabled="isProcessingPayment" @click.prevent="handlePayment">
                    VALIDER MA COMMANDE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

       <!-- Right Section: Summary -->
       <div class="col-12 col-md-5 order-1 order-md-2" :class="!isPhone ? 'pt-5' : ''">
         <div class="d-flex justify-content-start align-items-start mb-5" v-if="isPhone" @click="close()">
           <div class="back-button d-flex align-items-center justify-content-center ml-1">
             <img src="../../images/arrow-left-small.svg" alt="Back" style="width: 15px; height: 17.5px;" />
           </div>
         </div>
         <div class="raleway-reg-p18 pb-3 pt-3">Votre panier</div>
         <div class="card-checkout-items" :class="isPhone ? 'row' : ''">
           <div class="purchase-items-container w-100" :class="!hasValidConfiguration ? 'empty-cart' : 'h-100'">
             <div class="d-flex flex-column h-100 w-100 justify-content-center align-items-center" v-if="!hasValidConfiguration">
               <div class="raleway-reg-p15 text-center" style="opacity: 0.56;">Veuillez sélectionner la valeur de votre carte cadeau</div>
               <img src="../../images/empty_cart.png" alt="Panier vide" style="width: 98px; height: 98px; cursor: pointer;" @click="handleEmptyCartClick">
             </div>
             <div v-else>
              <div class="d-flex align-items-center" :class="isPhone ? 'flex-column' : ''">
                <img class="img-fluid" id="picture-sejour" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/carte_cadeau_img_1.png"></img>
                <p class="merriweather-reg-14 ml-2" :class="isPhone ? '' : 'text-center '">La valeur de la carte cadeau est de {{ giftcardPurchase.amount }}€</p>
              </div>
               <div class="d-flex flex-column" style="gap: 12px;">
                 <div class="d-flex justify-content-between">
                   <div class="raleway-semi-p15">Montant total</div>
                   <div class="d-flex align-items-center justify-content-end" style="gap: 5px;" v-if="promoDiscountAmount > 0">
                     <div class="raleway-reg-p15 mb-0 discounted-amount text-light-gray">
                       <s>{{ giftcardPurchase.amount }}€</s>
                     </div>
                     <div class="raleway-reg-p15">
                       {{ giftcardPurchase.amount - promoDiscountAmount }}€
                     </div>
                     <div class="discount-percentage raleway-reg-p12" v-if="promoDiscountPercentageText != ''">
                       {{ promoDiscountPercentageText }}
                     </div>
                   </div>
                   <div class="raleway-reg-p15" v-else>{{ giftcardPurchase.amount }}€</div>
                 </div>
                 <div class="border-bottom-gray my-2"></div>
                 <div class="d-flex justify-content-between">
                   <div class="raleway-semi-p15">Montant total à payer</div>
                   <div class="raleway-semi-p15">{{ totalAmountToPay.toFixed(2) }}€</div>
                 </div>
               </div>
               <div class="d-flex flex-column promo-container mt-4">
                 <label for="code_promo" class="raleway-semi-p15 text-uppercase mb-0">Code exclusif</label>
                 <div
                   class="d-flex align-items-center"
                   :style="{ gap: isPhone ? '14px' : '20px', height: isPhone ? '55px' : '' }"
                 > 
                   <div class="position-relative col-8 col-md-8 px-0 w-100">
                     <input v-model="code_promo" type="text" class="w-100" :class="{'border-green': promoDiscountPercentageText != '' && isButtonDisabled, 'border-red': promoCodeValidity === 'false' || promoCodeValidity === 'null' || promoCodeValidity === 'notvalid'}"/>
                     <i
                       v-if="promoDiscountPercentageText != '' && isButtonDisabled"
                       class="fa fa-check fa-lg text-green tick-icon"
                     ></i>
                     <i
                       v-else-if="promoCodeValidity === 'false' || promoCodeValidity === 'null' || promoCodeValidity === 'notvalid'"
                       class="fa-solid fa-xmark fa-lg cross-icon" style="color: red;"
                     ></i>
                   </div>
                   <button :disabled="this.isButtonDisabled" style="display:inline;cursor:pointer;" id="code_button" class="hortense-btn-primary w-100" :class="isPhone ? 'mb-3' : ''" @click="applyCode">VALIDER</button>
                 </div>
                 <p v-if="promoDiscountPercentageText != '' && isButtonDisabled" class="raleway-reg-p12 text-green mb-0">*Votre code exclusif a été appliquée.</p>
                 <p v-else-if="promoCodeValidity === 'false' || promoCodeValidity === 'null' || promoCodeValidity === 'notvalid'" class="raleway-reg-p12 mb-0" style="color: red">*Votre code exclusif non reconnu..</p>
               </div>
             </div>
           </div>
         </div>
       </div>
    </div>
  </div>

  <!-- Confirmation Page -->
  <div v-else-if="bookingConfirmed" class="w-100">
    <GiftcardConfirmed :gift-card-purchase="giftcardPurchase" :purchase-total="totalAmountToPay" @close="close()" />
  </div>
</div>
</template>

<script>
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import fetcher from "packs/shared/api.js";
import GiftcardConfirmed from "../../components/giftcards/GiftcardConfirmed.vue";
import GiftcardReassurance from "../../components/giftcards/GiftcardReassurance.vue";
import vSelect from "vue-select";

export default {
  name: 'giftcard-payment',
   components: {
     VueDatePicker,
     GiftcardConfirmed,
     GiftcardReassurance,
     vSelect
   },
  props: {
    user: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      giftcardPurchase: {
        purchase_type: 'beneficiary',
        amount: 0,
        personal_message: '',
        scheduled_date: null,
        sender: {
          first_name: '',
          last_name: '',
          email: '',
          company_name: '',
          vat_number: '',
          phone: ''
        },
        receiver: {
          first_name: '',
          last_name: '',
          email: ''
        },
        client_secret: null,
        payment_id: null,
        stripe_customer_id: '',
        state: 'completed'
      },
      cardDetails: {
        lastFourDigits: null,
        type: null,
        expiryMonth: null,
        expiryYear: null,
        holder: null
      },
      currentStep: 1,
      isProcessingPayment: false,
      acceptConditions: false,
      stripeKey: document.querySelector("meta[name='stripe-key']").getAttribute("content"),
      stripe: null,
      paymentIntentId: null,
      clientSecret: null,
      displayError: null,
      card: null,
      status: {
        createToken: null,
        createCustomer: null,
        addCard: null,
        paymentIntent: null,
        confirmCardPayment: null,
        createGiftCardPurchase: null
      },
       bookingConfirmed: false,
       sessionId: 'gc_' + Math.random().toString(36).substr(2, 12),
       amountsList: [],
       code_promo: null,
       isButtonDisabled: false,
       promoDiscountAmount: 0,
       promoDiscountPercentageText: '',
       promoCodeValidity: '',
       discountPercentage: 0
     };
   },
   
   beforeMount() {
     this.amountsList = [];
     for (let i = 0, val = 100; val <= 1000; i++, val += 50) {
       this.amountsList[i] = { id: val, name: `${val} €` };
     }
   },
   beforeDestroy() {
    const tagsAccordions = document.getElementById('tagsAccordions');
    if (tagsAccordions) {
      tagsAccordions.style.display = 'block';
    }
   },
   mounted() {
     if (this.user) {
       const fields = ['first_name', 'last_name', 'email', 'stripe_customer_id'];
       fields.forEach(field => {
         if (this.user[field]) {
           this.giftcardPurchase.sender[field] = this.user[field];
         }
       });
       this.giftcardPurchase.stripe_customer_id = this.user.stripe_customer_id || '';
     }
     if (this.$refs.errorsCard) {
       this.displayError = this.$refs.errorsCard;
     }
     const tagsAccordions = document.getElementById('tagsAccordions');
      if (tagsAccordions) {
        tagsAccordions.style.display = 'none';
      }
   },

  methods: {
    close() {
      window.location.href = '/carte-cadeau';
    },

    togglePurchaseType(type) {
      if (this.giftcardPurchase.purchase_type === type) {
        this.giftcardPurchase.purchase_type = 'beneficiary';
      } else {
        this.giftcardPurchase.purchase_type = type;
      }
    },

    changeStep(step) {
      switch (step) {
        case 2:
          if (this.validateStep(1)) {
            this.currentStep = step;
            this.$nextTick(() => {
              this.scrollToSection('step-2');
            });
          }
          break;
        case 3:
          if (this.validateStep(2)) {
            this.currentStep = step;
            this.$nextTick(() => {
              this.scrollToSection('step-3');
            });
          }
          break;
        case 4:
          this.currentStep = step;
          this.$nextTick(() => {
            this.scrollToSection('step-4');
            this.mountStripeElements();
          });
          break;
      }
    },

    scrollToSection(sectionId, headerOffset = 100) {
      const section = document.getElementById(sectionId);
      if (section) {
        const y = section.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    },

    validateStep(step) {
      if (step === 1) {
        return this.giftcardPurchase.amount >= 50;
      }

      if (step === 2) {
        const { purchase_type, sender, receiver } = this.giftcardPurchase;

        const requiredFields = {
          personal: ['sender.first_name', 'sender.last_name', 'sender.email'],
          beneficiary: [
            'sender.first_name', 'sender.last_name', 'sender.email',
            'receiver.first_name', 'receiver.last_name', 'receiver.email'
          ],
          entreprise: [
            'sender.company_name', 'sender.vat_number', 'sender.first_name', 'sender.last_name',
            'sender.phone', 'sender.email'
          ],
        };

        const fieldsToCheck = requiredFields[purchase_type] || [];

        return fieldsToCheck.every(path => {
          const value = path.split('.').reduce((acc, key) => acc?.[key], this.giftcardPurchase);
          return !!value?.toString().trim();
        });
      }

      return true;
    },

    async initCreateCardToken() {
      try {
        const response = await this.stripe.createToken(this.cardNumber);
        if (response.error) {
          this.status.createToken = false;
          console.log("Failed createToken");
          console.log(response.error);
        } else {
          this.status.createToken = true;
          this.cardToken = response.token;
        }
      } catch (e) {
        this.status.createToken = false;
        console.log("Failed initCreateCardToken");
        console.log(e);
      }
    },

    async initCreateStripeCustomer() {
      try {
        const createCustomerResponse = await fetcher.post("/create_customer", {
          card_token: this.cardToken,
          user: {
            email: this.giftcardPurchase.sender.email,
            first_name: this.giftcardPurchase.sender.first_name,
            last_name: this.giftcardPurchase.sender.last_name
          }
        });
        this.status.createCustomer = true;
        this.giftcardPurchase.stripe_customer_id = createCustomerResponse.data.stripe_customer_id;
      } catch (e) {
        this.status.createCustomer = false;
        console.error("Failed initCreateStripeCustomer", e?.response?.data || e.message);
        alert("Payment failed: Your card was declined. Please use a different card or contact your bank.");
      }
    },

    async initPaymentIntent() {
      try {
        const response = await fetcher.post("/gift_card/payment", {
          sender_user: {
            email: this.giftcardPurchase.sender.email,
            first_name: this.giftcardPurchase.sender.first_name,
            last_name: this.giftcardPurchase.sender.last_name,
            stripe_customer_id: this.giftcardPurchase.stripe_customer_id
          },
          receiver_user: {
            email: this.giftcardPurchase.receiver.email,
            first_name: this.giftcardPurchase.receiver.first_name,
            last_name: this.giftcardPurchase.receiver.last_name
          },
          gift_card: {
            amount: this.totalAmountToPay,
            number: 'TEMP-' + Math.random().toString(36).substr(2, 9)
          }
        });
        this.status.paymentIntent = true;
        this.paymentIntentId = response.data.payment_intent_id;
        this.clientSecret = response.data.client_secret;
      } catch (e) {
        this.status.paymentIntent = false;
        console.log("Failed initPaymentIntent");
        console.log(e);
      }
    },

    async initConfirmCardPayment() {
      try {
        const response = await this.stripe.confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.cardNumber
          }
        });
        if (response.error) {
          console.log("Failed confirmCardPayment");
          console.log(response.error);
          this.status.confirmCardPayment = false;
          if (this.displayError) {
            this.displayError.textContent = response.error.message;
          }
        } else {
          this.status.confirmCardPayment = true;
        }
      } catch (e) {
        this.status.confirmCardPayment = false;
        console.log("Failed initConfirmCardPayment");
        console.log(e);
      }
    },

    hasStatusError() {
      const error = Object.values(this.status).find((el) => el === false);
      return error === false ? true : false;
    },

    async handlePayment() {
      if (this.displayError) {
        this.displayError.textContent = "";
      }
      this.isProcessingPayment = true;

      await this.initCreateCardToken();

      if (!this.hasStatusError()) {
        if (!this.giftcardPurchase.stripe_customer_id) {
          await this.initCreateStripeCustomer();
        }
      }

      if (!this.hasStatusError() && this.totalAmountToPay > 0) {
        await this.initPaymentIntent();
        await this.initConfirmCardPayment();
      }

      setTimeout(() => {
        if (!this.hasStatusError()) {
          this.createGiftCardPurchase();
        }
      }, 1000);
      this.isProcessingPayment = false;
    },

    async mountStripeElements() {
      await this.$nextTick();

      if (!document.querySelector("#card-number")) {
        console.warn("Stripe input fields not found in DOM yet");
        return;
      }

      if (!this.stripe) {
        this.stripe = Stripe(this.stripeKey);
      }

      const elements = this.stripe.elements();

      const elementStyles = {
        base: {
          color: "rgba(0, 0, 0, 0.9)",
          fontWeight: "600",
          fontSize: "12px",
          fontFamily: "Raleway, sans-serif",
          fontStyle: "normal",
          lineHeight: "18px",
          fontSmoothing: "antialiased",
          "::placeholder": {
            color: "rgba(0, 0, 0, 0.5)",
            fontWeight: "600"
          },
          ":-webkit-autofill": {
            color: "rgba(0, 0, 0, 0.5)"
          }
        },
        invalid: {
          color: "#E25950",
          "::placeholder": {
            color: "#FFCCA5"
          }
        }
      };

      const elementClasses = {
        focus: "focused",
        empty: "empty",
        invalid: "invalid"
      };

      this.cardNumber = elements.create("cardNumber", {
        style: elementStyles,
        classes: elementClasses
      });
      this.cardNumber.mount("#card-number");

      this.cardExpiry = elements.create("cardExpiry", {
        style: elementStyles,
        classes: elementClasses
      });
      this.cardExpiry.mount("#card-expiry");

      this.cardCvc = elements.create("cardCvc", {
        style: elementStyles,
        classes: elementClasses
      });
      this.cardCvc.mount("#card-cvc");

      if (this.$refs.errorsCard) {
        this.displayError = this.$refs.errorsCard;
      }
    },

    async createGiftCardPurchase() {
      try {
        const res = await fetcher.post("/gift_card_purchases", {
          gift_card_purchase: {
            amount: this.giftcardPurchase.amount,
            personal_message: this.giftcardPurchase.personal_message,
            scheduled_date: this.giftcardPurchase.scheduled_date,
            sender: this.giftcardPurchase.sender,
            receiver: this.giftcardPurchase.receiver,
            purchase_type: this.giftcardPurchase.purchase_type,
            payment_id: this.paymentIntentId,
            client_secret: this.clientSecret,
            session_id: this.sessionId,
            promo_code: this.promoDiscountAmount > 0 ? this.code_promo : null, 
            discount: this.promoDiscountAmount,
            state: 'completed'
          }
        });
        
         // Store purchase data in localStorage
         localStorage.setItem('giftcardPurchase', JSON.stringify(this.giftcardPurchase));
         localStorage.setItem('purchaseTotal', JSON.stringify(this.totalAmountToPay));
         
         // Redirect to confirmation page
         window.location.href = '/carte-cadeau/confirmation-paiement';

        this.status.createGiftCardPurchase = true;
        this.bookingConfirmed = true;
      } catch (e) {
        this.status.createGiftCardPurchase = false;
        console.log("Failed create gift card purchase");
        console.error(e);
      }
    },

    resetDiscountState() {
      this.promoDiscountAmount = 0;
      this.promoDiscountPercentageText = '';
      this.isButtonDisabled = false;
      this.promoCodeValidity = '';
      this.discountPercentage = 0;
    },

    async applyCode() {
      try {
        const today = new Date();
        today.setDate(today.getDate() + 1);
        const response = await fetcher.get('/user_codes/' + this.code_promo);
        const codeData = response.data;

        if (this.promoDiscountAmount > 0 && codeData && this.code_promo.trim() !== '') {
          this.resetDiscountState();
        }

        if (
          codeData.code_status === true &&
          today <= new Date(codeData.expiry_date) &&
          today >= new Date(codeData.validity_date) &&
          !codeData.code_utilization_date
        ) {
          if (codeData.code_type === 8 || codeData.code_type === '8') {
            const discountPercentage = parseInt(codeData.code_type_description);
            const discount = (this.giftcardPurchase.amount * discountPercentage) / 100;
            this.discountPercentage = discountPercentage;
            this.promoDiscountAmount = discount;
            this.isButtonDisabled = true;
            this.promoDiscountPercentageText = `-${discountPercentage}%`;
            this.promoCodeValidity = null;
          } else {
            this.promoCodeValidity = 'notvalid';
          }
        } else {
          this.promoCodeValidity = 'false';
        }
      } catch (e) {
        this.promoCodeValidity = 'null';
        console.error(e);
      }
    },

    getPercentageAmount(amount, percentage) {
      return (amount * percentage) / 100;
    },

    handleCalendarIconClick() {
      this.$nextTick(() => {
        const calendarInput = this.$el.querySelector('.vd-picker__input');
        if (calendarInput) {
          calendarInput.click();
        }
      });
    },

    handleEmptyCartClick() {
      this.currentStep = 1;
      this.$nextTick(() => {
        this.scrollToSection('step-1');
      });
    }
  },

   computed: {
     isPhone() {
       return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
     },

     totalAmountToPay() {
       return this.giftcardPurchase.amount - this.promoDiscountAmount;
     },

     hasDefaultAmount() {
       return this.giftcardPurchase.amount > 0;
     },

     hasValidConfiguration() {
       return this.giftcardPurchase.amount > 0;
     }
   },

    watch: {
      code_promo() {
        if (this.code_promo === '') {
          this.resetDiscountState();
        }
      },
      'giftcardPurchase.amount'() {
        this.resetDiscountState();
      }
    }
};
</script>

<style scoped lang="scss">
#giftcard-payment {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .back-button {
    width: 40px;
    height: 38px;
    border-radius: 5px;
    background: #00000029;

    img {
      width: 23px;
      margin-left: 8px;
    }
  }

  .link-hortense {
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
  }

  .text-underline {
    text-decoration: underline;
    cursor: pointer;
  }

  .container-giftcard {
    width: 93%;

    .card-checkout-items {
      background-color: #F7F7F7;
      display: flex;
      flex-direction: column;
      align-items: start;
      min-height: 529px;
      max-height: 100%;
      overflow: auto;
      padding: 26px 22px 26px 22px;
      position: sticky;
      top: 5%;
    }
  }



  .information-section {
    .line-form {
      label {
        display: flex;
        flex-direction: column;
        font-family: $Raleway;
        font-weight: 500;
        font-size: 12px;
        color: #000000;
        line-height: 18px;
      }
      input[type="text"],
      input[type="number"] {
        border: 1px solid rgba(0, 0, 0, 0.5);
        padding: 16px;
        gap: 10px;
        height: 56px;
        border-radius: 8px;
        margin-top: 8px;

        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
          width: 100%;
        }

        &:focus {
          outline: none;
        }
      }
    }
  }

  .personalise-section {
    .form-text-area {
      width: 100%;
      height: 113px;
      border-radius: 13px;
      border: 1px solid rgba(59, 97, 82, 1);
      padding: 13px;
      font-family: $Raleway;
      font-weight: 500;
      font-size: 12px;
      &:focus {
        outline: none;
      }
    }
    textarea::placeholder {
      color: rgba(128, 128, 128, 1);
      font-family: $Raleway;
      font-weight: 300;
      font-size: 15px;
    }

    .date-picker-container {
      background: rgba(247, 247, 247, 1) 0% 0% no-repeat padding-box;
      height: 47px;
      width: 414px;
      .calendar-container {
        position: relative;
        display: inline-block;
        width: 176px;
      }

      .calendar-input {
        border: none;
        padding-left: 55px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: white;
      }

      .calendar-input::-webkit-calendar-picker-indicator {
        opacity: 0;
        cursor: pointer;
        z-index: 2;
        position: absolute;
        right: 0;
      }

      .calendar-icon {
        position: absolute;
        top: 50%;
        left: 0.75rem;
        transform: translateY(-50%);
        width: 18px;
        height: 18px;
        background-image: url('../../images/icon_calendar.svg');
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 1;
      }
    }
  }

  .payment-section {
    #card-errors {
      color: red;
    }

    .card-stripe {
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #F7F7F7;
      padding: 32px 24px;
      gap: 4px;
    }

    .card-stripe .field {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 16px;
      gap: 10px;
      width: 346px;
      height: 50px;
      border: 1px solid rgba(0, 0, 0, 0.5);
      border-radius: 8px;

      input {
        font-family: $Raleway;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
      }

      input::placeholder {
        color: rgba(0, 0, 0, 0.5);
      }
    }

    .payment-icons {
      gap: 10px;
    }

    .card-stripe .field.half-width {
      width: 47%;
    }

    .card-stripe .field.quarter-width {
      width: calc(25% - 10px);
    }

    .card-stripe .baseline {
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      bottom: 0;
      background-color: #cfd7df;
      transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    .card-stripe .input {
      width: 100%;
      color: #32325d;
      background-color: transparent;
    }

    .card-stripe input[type="text"] {
      appearance: none;
      outline: none;
      border-style: none;
      width: 100%;
      height: 100%;
      background-color: transparent;
    }
  }


  .total-container {
    padding-left: 2.5rem;

    @media screen and (max-width: 768px) {
      padding-left: 1.5rem;
    }
  }

  .delivery-note {
    height: 117px;
    background: #A5D3AE48 0% 0% no-repeat padding-box;
    border-radius: 7px 7px 0px 7px;
    opacity: 1;
    padding: 22px 29px 20px 42px;
  }

  .empty-cart {
    height: 529px;
  }

  .promo-container {
    input[type="text"] {
      height: 48px;
      border: 1px solid #707070;
      border-radius: 4px;
      padding: 7px;
      padding-left: 14px;

      &:focus {
        outline: none;
      }
    }

    .tick-icon {
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }

    .cross-icon {
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }
  }

  text-light-gray {
    color: rgba(0, 0, 0, 1);
    opacity: 0.42;
  }

  .discount-percentage {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px;
    gap: 10px;
    width: 32px;
    height: 18px;
    background: rgba(165, 211, 174, 0.47);
    border-radius: 2px;
  }

  .border-green {
    border-color: #3B6152 !important;
    color: #3B6152;
  }

  .border-red {
    border-color: red !important;
    color: red;
  }
}

.giftcard-payment-phone {
  width: 100% !important;
  padding-top: 30%;

  .back-button {
    width: 36px !important;
    height: 38px !important;

    img {
      margin-left: 0 !important;
      width: 20px !important;
    }
  }

  .card-checkout-items {
    min-height: 327px !important;
    max-height: 852px !important;
    .empty-cart {
      height: 327px !important;
    }
  }

  .delivery-note {
    padding: 16px !important;
  }

  .raleway-it-l12 {
    font-size: 12px;
  }

  .promo-container {
    input[type="text"] {
      height: 42px !important;
    }

    .hortense-btn-primary {
      height: 42px !important;
      width: 123px !important;
    }
  }
}

.border-bottom-gray {
  border-bottom: 0.5px solid #707070;
}

.border-bottom-black {
  border-bottom: 1px solid #000000;
}

.light-gray-text {
  color: rgba(0, 0, 0, 1);
}

.link-hortense {
  color: rgba(59, 97, 82, 1);
}
.text-green {
  color: #3B6152;
}
.link-text {
  color: #3B6152;
  text-decoration: underline;
  cursor: pointer;
}

.hortense-btn-primary {
  cursor: pointer;
}

.raleway-it-l12 {
  font-family: $Raleway;
  font-style: italic;
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
}

.nav-phone {
  .logo {
    z-index: 1 !important;
  }
}

.gift-card-input {
  input {
    border-radius: 15px;
    border: 1px solid #3B6152;
    padding: 10px;
    font-family: $Raleway;
    font-weight: 400;
    font-size: 15px;
    &:focus {
      outline: none;
    }
  }
  .select-item {
    border: 1px solid #3B6152;
    padding: 7px;
    border-radius: 15px;
    font-family: $Raleway;
    font-weight: 400;
    font-size: 15px;
    &:focus {
      outline: none;
    }
  }

  label {
    display: flex;
    flex-direction: column;
    color: #000000;
    line-height: 18px;
  }
}
#picture-sejour {
  width: 400px;
  margin-bottom: 15px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
</style>

<style lang="scss">
.no-border .vs__dropdown-toggle {
  border: none !important;
  box-shadow: none !important;
  padding: 0;
  cursor: pointer;
}

.vs__dropdown-option--highlight {
  background: #3B6152 !important;
}

.vs__dropdown-menu {
  margin-top: 4px !important;
  z-index: 50 !important;
}

.vs__selected-options {
  height: 28px !important;
  white-space: nowrap !important;
}

.dropdown-up .vs__dropdown-menu {
  bottom: 100% !important;
  top: auto !important;
}
</style>
